<template>
    <div v-if="isUserDataLoaded">
        <v-layout>
            <router-view></router-view>
        </v-layout>
    </div>
</template>
<script>
    import api from '@/api';
    import operations from "@/operations";
    export default {
        provide() {
            return {
                getUserProfile : () => {
                    return this.user;
                },
                getUserProfileOrganization : () => {
                    return this.organization;
                }
            }
        },
        data() {
            return {
                user : {},
                organization : {},
                isUserDataLoaded : false
            }
        },
        mounted() {
            this.get().then(()=> {
                this.isUserDataLoaded = true;
            })
        },
        methods: {
            get() {
                this.$root.$emit('showGlobalOverlay');
                return new Promise((resolve) => {
                    operations.getUserProfileAndOrganization().then((userAndOrg) => {
                        this.user = userAndOrg.user;
                        this.organization = userAndOrg.organization;
                        this.$root.$emit('hideGlobalOverlay');
                        resolve(userAndOrg);
                    });
                });
            },
            loadProfile() {
                this.$router.push({'path':'/user-profile'});
            }
        }
    }
</script>